import { Navigate, Outlet, useNavigate } from "react-router-dom";


export const AuthRouter = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    return (
        !token ? <Navigate to={'/login'}/> : <Outlet />
    );
}